import { render } from "./FormAccount.vue?vue&type=template&id=eff35d12&scoped=true"
import script from "./FormAccount.vue?vue&type=script&lang=js"
export * from "./FormAccount.vue?vue&type=script&lang=js"

import "./FormAccount.vue?vue&type=style&index=0&id=eff35d12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eff35d12"]])

export default __exports__